import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-down",
  "use": "icon-chevron-down-usage",
  "viewBox": "0 0 10 5",
  "content": "<symbol viewBox=\"0 0 10 5\" id=\"icon-chevron-down\"><path d=\"M9 1L4.997 4.431 1 1.004\" stroke=\"currentColor\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/icons/icon-chevron-down.svg
// module id = 858
// module chunks = 74